import axios from "../../../axios";

export const getSampleBotList = async (payload) => {  
  let data
  try {        
      data  = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/sample`);  
    return data.data
  } catch (e) {
    console.log("error while gettings processes", e)
  }
};
